<template>
  <v-list-item three-line>
    <v-list-item-avatar>
      <v-icon large :color="color">mdi-account-circle</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-row no-gutters>
        <v-list-item-title>{{ first_name + ' ' + last_name }}</v-list-item-title>
        <v-list-item-subtitle>{{ phone_number }}</v-list-item-subtitle>
        <v-list-item-subtitle>{{ email }}</v-list-item-subtitle>
        <v-list-item-subtitle>Role: {{ role }}</v-list-item-subtitle>
      </v-row>
    </v-list-item-content>
    <v-list-item-action>
      <v-row>
        <v-btn rounded text @click="$emit('show', uuid)">
          show
          <v-icon right>mdi-open-in-new</v-icon>
        </v-btn>
        <v-btn color="red" rounded @click="$emit('ban', uuid)" text v-if="!locked_at">
          Ban
          <v-icon right>mdi-close</v-icon>
        </v-btn>
        <v-btn color="primary" rounded @click="$emit('unban', uuid)" text v-else>
          Unban
          <v-icon right>mdi-close</v-icon>
        </v-btn>
      </v-row>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  props: [
    "last_name",
    "first_name",
    "phone_number",
    "email",
    "role",
    "locked_at",
    "uuid"
  ],
  computed: {
    color() {
      if (this.role == "admin") return "primary";
      if (this.role == "super") return "lime";
      return "grey";
    }
  }
};
</script>

<style lang="scss" scoped></style>
